/* LALO "pay by card" button (2026-10-15, plans/2026-10-15-ring-size-picker.md, part B).
   Adds the item to the cart through the product form (a ring's size goes with it) and opens checkout.
   If the very same line is already in the cart it is not added twice. The price follows the variant:
   it copies the add-to-cart button's price, which the theme updates on every variant change. */
(() => {
  if (customElements.get('lalo-card-checkout')) return;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  class LaloCardCheckout extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('.lalo-card-checkout__button');
      this.price = this.querySelector('.lalo-card-checkout__price');
      this.form = this.closest('product-form')?.querySelector('form') || document.getElementById(this.dataset.formId);
      this.wrap = this.closest('product-form');
      this.button.addEventListener('click', () => this.go());

      const source = this.closest('.product-form__buttons')?.querySelector('.product-form__submit');
      if (source) {
        const sync = () => {
          const p = source.querySelector('.price-item--regular');
          if (p && p.textContent.trim()) this.price.textContent = p.textContent.trim();
          const off = source.hasAttribute('disabled') && source.getAttribute('aria-disabled') !== 'true';
          this.button.disabled = off;
        };
        this.observer = new MutationObserver(sync);
        this.observer.observe(source, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.ready = false;
    }

    error(message) {
      const box = this.wrap?.querySelector('.product-form__error-message-wrapper');
      const text = box?.querySelector('.product-form__error-message');
      if (!box || !text) return;
      text.textContent = message;
      box.hidden = !message;
    }

    async go() {
      if (!this.form || this.button.getAttribute('aria-busy') === 'true') return;
      if (this.form.laloRingSize && !this.form.laloRingSize.ensure()) return;
      this.error('');
      this.button.setAttribute('aria-busy', 'true');
      this.button.classList.add('loading');
      try {
        const data = new FormData(this.form);
        const id = String(data.get('id'));
        const props = {};
        for (const [k, v] of data.entries()) {
          const m = /^properties\[(.+)\]$/.exec(k);
          if (m && v) props[m[1]] = String(v);
        }
        const cart = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const same = (cart.items || []).some((it) => String(it.variant_id) === id
          && JSON.stringify(Object.entries(it.properties || {}).filter(([, v]) => v).sort())
             === JSON.stringify(Object.entries(props).sort()));
        if (!same) {
          const res = await fetch(`${root()}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
          const body = await res.json().catch(() => ({}));
          if (!res.ok || body.status) throw new Error(body.description || body.message || '');
        }
        window.location.href = `${root()}checkout`;
      } catch (e) {
        this.error(e.message || window.variantStrings?.unavailable || '');
        this.button.removeAttribute('aria-busy');
        this.button.classList.remove('loading');
      }
    }
  }

  customElements.define('lalo-card-checkout', LaloCardCheckout);
})();
